import { Injectable } from '@angular/core';
import { ReferentialItem } from '@app/core/models/shared/referential-item.model';

@Injectable({
  providedIn: 'root'
})
export class DropdownHelper {

  private YesOrNoDropdownList: ReferentialItem[] = [{ Id: 1, Label: 'Oui' }, { Id: 0, Label: 'Non' }];
  private YesOrNoOrNaDropdownList: ReferentialItem[] = [{ Id: 1, Label: 'NA' }, { Id: 2, Label: 'Oui' }, { Id: 4, Label: 'Non' }];
  private YesOrNoAsFlagsDropdownList: ReferentialItem[] = [{ Id: 2, Label: 'Oui' }, { Id: 1, Label: 'Non' }];

  public getYesOrNoDropdownList() {
    return this.YesOrNoDropdownList.slice();
  }

  public getYesOrNoOrNaDropdownList() {
    return this.YesOrNoOrNaDropdownList.slice();
  }

  public getYesOrNoAsFlagsDropdownList() {
    return this.YesOrNoAsFlagsDropdownList.slice();
  }
}
